import { useCallback } from 'react';
import type { DeletedBy } from '@immo/api-contract';
import { useTranslations } from '@/i18n/use-translations';
import type { SortValue } from '@/components/sortable-table';

export function useDeletedByLabel(): (deletedBy: DeletedBy | null) => string {
  const t = useTranslations('pages.admin.deleted-by');

  return useCallback(
    (deletedBy) => {
      if (deletedBy === null) return t('unknown');

      if (deletedBy.type === 'SYSTEM') return t('system');

      if (deletedBy.name === null) return t('unknown');

      if (deletedBy.type === 'ADMIN') return t('operator', { name: deletedBy.name });

      return deletedBy.name;
    },
    [t],
  );
}

/** `null` exactly where the label is the "Unbekannt" placeholder, so sortRows groups those rows last in both directions. */
export function deletedBySortValue(label: string, deletedBy: DeletedBy | null): SortValue {
  return deletedBy === null || (deletedBy.type !== 'SYSTEM' && deletedBy.name === null) ? null : label;
}
